<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8" lg="6">
          <b-card no-body class="p-4">
            <b-card-body>
              <!-- <h2>F1-UWSS <small>Partner Login</small></h2> -->
              <h2> {{custom && custom.slogan ? custom.slogan : 'F1-UWSS'}}  <small>Partner Login</small></h2>
              <hr>
              <p class="text-muted">Sign into your account
                <b-button variant="link" @click="reset()" class="float-right px-0">Forget password or OTP ?</b-button>
              </p>
              <b-input-group class="mb-3">
                <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                <input type="text" class="form-control" placeholder="Email" v-model="m.username" @keyup.enter="login()">
              </b-input-group>
              <b-input-group class="mb-3">
                <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                <input type="password" class="form-control" placeholder="Password" v-model="m.password" @keyup.enter="login()">
              </b-input-group>
              <transition name="fade" :duration="3000">
                <b-input-group class="mb-3" v-show="require_otp">
                  <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                  <input type="text" class="form-control" placeholder="OTP Code (Option)" v-model="m.otp" @keyup.enter="login()">
                </b-input-group>
              </transition>

              <b-row>
                <b-col cols="6">
                  <b-checkbox v-model="save_username">Remember me</b-checkbox>
                  <small v-if="custom.version">v{{ custom.version }}</small>
                </b-col>
                <b-col cols="6" class="text-right">
                  <b-button variant="primary" class="px-4" @click="login()">Login</b-button>
                </b-col>
              </b-row>
              <hr>
              <b-row class="text-center" v-if="custom.slogan.indexOf('F1-UWSS') > 0">
                <!-- <b-col cols="3"> </b-col> -->
                <b-col> <img class="text-center" src="/img/F1security.png" alt="Hello, F1security"> </b-col>
                <!-- <b-col cols="3"> </b-col> -->
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { auth, Custom } from '@/service';
import * as _ from 'lodash'
import config from '@/config';

export default {
  data: () => ({ auth, custom : Custom.default, check_preflight : false, require_otp : false, save_username: false, m: { username: '', password: '', otp : '' }, lock: false, }),
  computed: {
    slogan() { return this.custom && this.custom.slogan ? this.custom.slogan : 'F1-UWSS' }
  },
  methods: {
    reset() {
      this.$router.push({ name: 'auth_reset' });
    },
    async preflight() {
      // return true or false
      return await auth.preflight(this.m.username, this.m.password);
    },
    async login() {
      if(_.isEmpty(this.m.username)) { return this.$toastr.e('Please enter your username (email)'); }
      if(_.isEmpty(this.m.password)) { return this.$toastr.e('Please enter your password.'); }
      if(this.lock) { return this.$toastr.i('Signing in....'); }
      try {
        if(!this.check_preflight) {
          this.require_otp = await this.preflight();
          this.check_preflight = true;
        }
        if(this.require_otp && !this.m.otp) { return this.$toastr.i('please input OTP', 'require') }
      } catch (e) { return this.$toastr.w(e.data ? e.data.message : e.statusText); }

      this.lock = true;
      try {
        let rs = await auth.login(this.m.username, this.m.password, this.m.otp);
        if(rs) {

          console.log(this.auth.profile.permissions)
          if(this.save_username) { window.localStorage.setItem('username', this.m.username); } else { window.localStorage.removeItem('username'); }

          if(this.auth && this.auth.profile && this.auth.profile.permissions == 'billing') {
            this.$router.push({ name: 'plan' }); // 대시보드 경로로 변경 필요함
          } else {
            this.$router.replace(this.$route.query.redirect || '/'); // 대시보드 경로로 변경 필요함
          }

        } else { return this.$toastr.w('login failed'); }
      } catch(e) { this.$toastr.w(e.data ? e.data.message : e.statusText); }
      this.lock = false;
    }
  },
  created() { console.log('[vue] login', 'created'); },
  destroyed() { console.log('[vue] login', 'destroyed'); },
  mounted() {
    this.custom = Custom.setting()
    console.log('[vue] login', 'mounted');
    if(auth.loggedIn()) { this.$router.replace('/');  }// 대시보드 경로로 변경 필요함
    if(window.localStorage.getItem('username')) { console.log('load', 'username'); this.save_username = true; this.m.username = window.localStorage.getItem('username'); }
    this.custom.version = config.version
  }
}

</script>
